import { useInternalLink } from '@/common/hooks/useInternalLink';
import { useMemo } from 'react';

// Just incase the data is unsorted, lets sort it.
const sortCrumbs = (a, b) => a.category_level > b.category_level;

// Generates the path for the category.
const getPath = (path, suffix) => {
  if (path) {
    return `/${path}${suffix || ''}`;
  }

  // If there is no path this is just a dead link.
  return '#';
};

/**
 * Returns props necessary to render a Breadcrumbs component.
 *
 * @param {object} props
 * @param {object} props.breadcrumbsData - the breadcrumb query
 * @return {{
 *   currentCategory: string,
 *   currentCategoryPath: string,
 *   isLoading: boolean,
 *   normalizedData: array,
 *   handleClick: function
 * }}
 */
export const useBreadcrumbs = props => {
  const { breadcrumbsData } = props;
  const categoryUrlSuffix = '/';

  const normalizedData = useMemo(() => {
    if (breadcrumbsData && breadcrumbsData.categories.items.length) {
      const breadcrumbData = breadcrumbsData.categories.items[0].breadcrumbs;

      return (
        breadcrumbData &&
        breadcrumbData
          .map(category => ({
            category_level: category.category_level,
            text: category.category_name,
            path: getPath(category.category_url_path, categoryUrlSuffix),
          }))
          .sort(sortCrumbs)
      );
    }
  }, [categoryUrlSuffix, breadcrumbsData]);

  const { setShimmerType } = useInternalLink('category');

  return {
    currentCategory:
      (breadcrumbsData && breadcrumbsData.categories.items.length && breadcrumbsData.categories.items[0].name) || '',
    currentCategoryPath:
      (breadcrumbsData &&
        breadcrumbsData.categories.items.length &&
        `${breadcrumbsData.categories.items[0].url_path}${categoryUrlSuffix || ''}`) ||
      '#',
    normalizedData: normalizedData || [],
    handleClick: setShimmerType,
  };
};
